import { Box, styled } from '@mui/material';

export const DeliveryContentsTextContainer = styled(Box)`
  display: flex;
  gap: 0 ${({ theme }) => theme.layout.spacing.small};
`;
